module.exports = __webpack_public_path__ + "plugins/web/img/cmdinfo-header.7a61104c.jpg";